export enum UnderTitleMessageType {
  SUCCESS = 'SUCCESS',
  ERROR = 'error',
}

export enum ResponseMessageTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
}
